/**
 * Sorting order.
 */
export enum QuerySortOrder {
    /**
     * Descending.
     */
    Desc,
    /**
     * Ascending.
     */
    Asc,
}
